var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{attrs:{"id":"vis-container"}},[_c('svg',{staticClass:"svg-frame2",attrs:{"height":"1200"}}),_c('svg',{staticClass:"svg-frame",attrs:{"width":"1000","height":"300"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }